require('./brokerAdvancedSearchResult.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter, Prompt } = require('react-router-dom');
const classNames = require('classnames');

// @utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
const { getCityOfMarket } = require('utilities/micCodeHelper');
const { buildBuyProductLink } = require('utilities/productLinksHelper');
const { formatWithoutRound,formatAmount } = require('utilities/currencyHelper');
const { formatDate } = require('utilities/dateHelper');
const { taggingEventHandled } = require('utilities/taggingEventHandled');

// @commons
const Flag = require('components/broker/commons/flag/flag');
const { OKLink } = require('commonsComponents/OKLink');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKModal = require('components/commons/OKModal/OKModal');

// @components
const BrokerMiFIDUSPersonButton = require('mifid/components/brokerMiFIDUSPersonButton/brokerMiFIDUSPersonButton');
const { BrokerStockInformativeButton } = require('components/broker/brokerStockInformativeButton/brokerStockInformativeButton');
const BrokerAdvancedSearchResultRiskIndicator = require('./brokerAdvancedSearchResultRiskIndicator/brokerAdvancedSearchResultRiskIndicator');

// @actions
const BrokerClientWarningModalAction = require('actions/brokerClientWarningModal');
const morningstarPlansDgsCodeToSecIDActions = require('actions/morningstarPlansDgsCodeToSecID');
const BrokerProductAdvancedSearchActions = require('actions/brokerProductAdvancedSearch');
const BrokerAdvancedSearchTaggingActions = require('actions/brokerAdvancedSearchTagging');
const brokerNoStockAccountModalActions = require('actions/brokerNoStockAccountModal');

// @constants
const {
    TYPE_WARRANTS,
    TYPE_STOCKS, TYPE_ETFS,
    TYPE_PLANS, TYPE_FUNDS,
    BROKER_SMALL_FLAG_SIZE,
    MYPROFILE_BROKER_ERROR_URL,
    PERCENTAGE_SYMBOL,
    BROKER_HIRE_PENSION_PLAN_URL,
    DATE_FORMAT,
    ALTERNATIVE_FUNDS,
    BROKER_ADVANCED_SEARCH_UTAG_NAME,
    TYPE_CRYPTO
} = require('constants/index');

const { PROC_BROKER_FUNDS_PG_NAME, recordLinkV2 } = require('utilities/tagging')

const { ESG_PRODUCT } = require('constants/flagBasedFeatures');

class BrokerAdvancedSearchResult extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openModalUsPerson: false,
            isBlockingRouteChange: false,
        };
        this.handleBuy = this.handleBuy.bind(this);
        this.handleClickNameNonPlanLink = this.handleClickNameNonPlanLink.bind(this);
        this.handleClickNamePlanLink = this.handleClickNamePlanLink.bind(this);
        this.handleClickBuyProductLink = this.handleClickBuyProductLink.bind(this);
        this.handleClickBuyPlanLink = this.handleClickBuyPlanLink.bind(this);
        this.handleClickBuyFundLink = this.handleClickBuyFundLink.bind(this);
        this.handleStarClicked = this.handleStarClicked.bind(this);
    }

    componentDidMount() {
        const { checkPersonalInformationData } = this.props;
        checkPersonalInformationData();
    }

    handleClickNameNonPlanLink() {
        const { type, result } = this.props;
        this.props.productLinkNameTagging(type, result, false);
    }

    handleClickNamePlanLink() {
        const { history, type, result, getDgsCodeToSecIDURL } = this.props;
        const dgsCode = result.get('dgsCode');
        this.props.productLinkNameTagging(type, result, false);
        if (__CONTACT_CENTER__) {
            history.push(BROKER_HIRE_PENSION_PLAN_URL + result.get('customInstitutionSecurityId'));
        }
        else {
            getDgsCodeToSecIDURL(dgsCode);
        }
    }

    handleClickBuyProductLink() {
        const { type, result } = this.props;

        const url = buildBuyProductLink(type, result);
        this.props.productLinkNameTagging(type, result, true);
        this.handleBuy(url);
    }

    handleClickBuyPlanLink() {

        const { history, type, result, getDgsCodeToSecIDURL, flagBasedFeatures, immBrokerUsPersonBlock } = this.props;
        const dgsCode = result.get('dgsCode');
        const isUsPerson = immBrokerUsPersonBlock.get('isUsPerson');
        const ffUsPersonOpenBrokerageAccount = flagBasedFeatures.get('wealth_pension_plans_hire_us_person');
        recordLinkV2({
            eventCategory: 'broker/buscador-avanzado',
            eventAction: 'knowMore',
            eventLabel: dgsCode,
        });
        if (isUsPerson && ffUsPersonOpenBrokerageAccount) {
            this.setState({ openModalUsPerson: true })
        } else {
            this.props.buyButtonClick(dgsCode);
            this.props.productLinkNameTagging(type, result, true);
            if (__CONTACT_CENTER__) {
                history.push(BROKER_HIRE_PENSION_PLAN_URL + result.get('customInstitutionSecurityId'))
            }
            else {
                getDgsCodeToSecIDURL(dgsCode);
            }
        }

    }

    handleClickBuyFundLink() {
        const { history, type, result } = this.props;
        this.props.productLinkNameTagging(type, result, true);
        history.push(result.get('link'));
    }

    handleClickBuyCryptoLink() {
        const { history, result, type } = this.props;
        const url = buildBuyProductLink(type, result);
        history.push(url);
    }

    getMarketId(result) {
        const { type } = this.props;

        switch (type) {
            case TYPE_STOCKS:
                return result.get('ticker');
            case TYPE_PLANS:
                return result.get('dgsCode');
            case TYPE_ETFS:
            case TYPE_FUNDS:
            case ALTERNATIVE_FUNDS:
            case TYPE_WARRANTS:
                return result.get('isin');
            case TYPE_CRYPTO:
                return result.get('symbol');
        }
    }

    buildSearchResultLeftInfo() {
        const { result, type, flagBasedFeatures } = this.props;
        const isin = result.get('isin');
        const market = result.get('market');
        const countryCode = result.get('country');
        const isESGFund = result.get('esg');
        let marketloc; let flag; let content;
        const marketId = this.getMarketId(result);
        let subAssetClassSubtitle;
        let esgTag = '';

        if (result.get('market')) {
            marketloc = ' ' + getCityOfMarket(market) + ', ' + countryCode + ' | ';
            flag = <Flag countryCode={countryCode} pixelsSize={BROKER_SMALL_FLAG_SIZE} />;
        }
        let marketInfo = <div className="broker-advanced-search-result__left-info--isin">{flag}{marketloc}{marketId}</div>
        if (type === TYPE_CRYPTO) {
            marketInfo = <div className="broker-advanced-search-result__left-info--isin">{marketId}</div>
        }
        if (type === TYPE_PLANS) {
            content = (
                <div className="broker-advanced-search-result__left-info--shortname">
                    <OKLink
                        onClick={this.handleClickNamePlanLink}>
                        {result.get('shortName')}
                    </OKLink>
                </div>
            );
        } else {
            content = (
                <div className="broker-advanced-search-result__left-info--shortname">
                    <OKLink
                        to={result.get('link')}
                        onContextMenu={this.handleClickNameNonPlanLink}
                        onClick={() => {
                            taggingEventHandled(PROC_BROKER_FUNDS_PG_NAME, 'searchInteractionLink', result.get('shortName'), result.get('assetClass'))
                            if (type === ALTERNATIVE_FUNDS) {
                                taggingEventHandled(BROKER_ADVANCED_SEARCH_UTAG_NAME, 'clickFundName', isin)
                            }
                            this.handleClickNameNonPlanLink()
                        }}>
                        {result.get('shortName')}
                    </OKLink>
                </div>
            );
        }

        if (result.get('subAssetClass') !== result.get('assetClass')) {
            const subAssetClassText = `brokerAdvancedSearch-brokerAdvancedSearch_${result.get('subAssetClass')}`;
            subAssetClassSubtitle = (
                <div className="broker-advanced-search-result__left-info--sub-asset-class">
                    <FormattedText value={subAssetClassText} />
                </div>
            );
        }

        if (isESGFund && flagBasedFeatures.get(ESG_PRODUCT)) {
            esgTag = (
                <div className="broker-advanced-search-result__left-info--esg__tag">
                    <i className="broker-advanced-search-result__left-info--esg__icon" />
                    <FormattedText value={'brokerAdvancedSearch-brokerAdvancedSearch_esgTag'} />
                </div>
            );
        }

        const leftInfoAssetClassText = `brokerAdvancedSearch-brokerAdvancedSearch_${result.get('assetClass')}`;

        let riskIndicatorSection;
        if (type !== TYPE_STOCKS) {
            const risk = result.get('risk') && result.get('risk').split('of');
            riskIndicatorSection = risk ? <BrokerAdvancedSearchResultRiskIndicator risk={risk[0]} maxRisk={risk[1]} /> : null;
        }

        let stockIsin;
        if (type === TYPE_STOCKS) {
            stockIsin = (
                <p className="broker-advanced-search-result__left-info--isin">
                    {result.get('isin')}
                </p>
            );
        }

        return (
            <div className="col-sm-4 broker-advanced-search-result__left-info">
                <div className="broker-advanced-search-result__left-info--asset-class">
                    <FormattedText value={leftInfoAssetClassText} />
                </div>
                {subAssetClassSubtitle}
                {content}
                {marketInfo}
                {esgTag}
                {riskIndicatorSection}
                {stockIsin}
            </div>
        );
    }

    getTextQuotation() {
        const { type } = this.props;

        switch (type) {
            case TYPE_STOCKS:
            case TYPE_WARRANTS:
            case TYPE_ETFS:
                return "broker-rightsQuotation";
            case TYPE_PLANS:
            case TYPE_FUNDS:
                return "brokerSearchWidget-brokerSearchWidget_liquidationValue";
        }
    }

    handleBuy(buyLink) {
        const { history, immbrokerClientWarningModal, showClientWarningModal, result } = this.props;
        const clientPersonalInfoUpdated = immbrokerClientWarningModal.get('clientPersonalInfoUpdated');
        const isFetching = immbrokerClientWarningModal.get('isFetching');
        const isFetched = immbrokerClientWarningModal.get('isFetched');
        const quotation = result.get('quotation');

        if (!isFetched && !isFetching || quotation === '-') {
            history.push(MYPROFILE_BROKER_ERROR_URL);
        } else if (isFetched && !isFetching) {
            if (!clientPersonalInfoUpdated) {
                showClientWarningModal(history);
                this.setState({
                    nextLocation: buyLink,
                    isBlockingRouteChange: true
                });
            } else {
                history.push(buyLink);
            }
        }
        window.modalInstance = this;
    }

    getYtdTooltipContent() {
        return (
            <div>
                <h5 className="broker-advanced-search-result__ytd-tooltip-title">
                    <FormattedText value="brokerAdvancedSearch-brokerAdvancedSearch_rentabilityTooltipTitle" />
                </h5>
                <div className="broker-advanced-search-result__tooltip-text">
                    <FormattedText value="brokerAdvancedSearch-brokerAdvancedSearch_rentabilityTooltipText" />
                </div>
            </div>
        );
    }

    getDateTimeLastVariation(result) {
        const { type } = this.props;
        const date = result.get('quotationDate');
        const dayChangeDate = result.get('dayChangeDate');
        const hour = result.get('quotationTime');

        switch (type) {
            case TYPE_STOCKS:
            case TYPE_WARRANTS:
            case TYPE_ETFS:
                return `${date} | ${hour} ${formatText("brokerAdvancedSearch-brokerAdvancedSearch_hour")}`
            case TYPE_PLANS:
            case TYPE_FUNDS:
                return dayChangeDate;
        }
    }

    getUnits(number) {
        if (number == null) {
            return 2;
        }
        return Number.isInteger(parseFloat(number)) ? 2 : number.toString().split('.')[1].length;
    }

    buildBuyButton() {
        const { type, result, hasNoStockContracts, showModal } = this.props;
        const isin = result.get('isin');
        const market = result.get('market');
        const dgsCode = result.get('dgsCode');
        const textButton = (<FormattedText value="broker-buySellBtnText" />);
        const isFetchingDgs = result.get('isFetchingDgs', false);
        const isClickBuyProduct = result.get('isClickBuyProduct', false);
        const emptyContracts = hasNoStockContracts;

        if (type === TYPE_PLANS) {
            return (
                <OKButton
                    id={dgsCode}
                    modifier="secondary"
                    size="small"
                    onClick={this.handleClickBuyPlanLink}
                    loading={isFetchingDgs && isClickBuyProduct}
                >
                    {textButton}
                </OKButton>
            );
        } else if(type === ALTERNATIVE_FUNDS) {
            return (
                <OKButton
                    modifier="secondary"
                    size="small"
                    onClick={() => {
                        taggingEventHandled(BROKER_ADVANCED_SEARCH_UTAG_NAME, 'buyFundButton', isin)
                        this.handleClickBuyFundLink()
                    }}
                >
                    <FormattedText value="brokerWealth-hireAlternativeFundBtnText" />
                </OKButton>
            );
        } else if (type === TYPE_FUNDS) {
            return (
                <OKButton
                    modifier="secondary"
                    size="small"
                    onClick={() => {
                        taggingEventHandled(PROC_BROKER_FUNDS_PG_NAME, 'searchInteractionButton', result.get('shortName'), result.get('assetClass'))
                        this.handleClickBuyFundLink()
                    }}
                >
                    {textButton}
                </OKButton>
            );
        } else if (type === TYPE_CRYPTO) {
            return (
                <OKButton
                        modifier="secondary"
                        size="small"
                        onClick={() => {
                            this.handleClickBuyCryptoLink()
                        }}
                    >
                        {textButton}
                </OKButton>
            )
        } else {
            if (emptyContracts) {
                return (
                    <OKButton
                        modifier="secondary"
                        onClick={showModal}
                        size="small"
                    >
                        {textButton}
                    </OKButton>
                );
            } else {
                return (
                    <BrokerStockInformativeButton
                        productType={type}
                    >
                        <BrokerMiFIDUSPersonButton
                            modifier="secondary"
                            onClick={this.handleClickBuyProductLink}
                            size="small"
                            isinId={isin}
                            marketId={market}
                        >
                            {textButton}
                        </BrokerMiFIDUSPersonButton>
                    </BrokerStockInformativeButton>
                );
            }
        }
    }

    handleStarClicked() {
        const { result, addProductToList, deleteProductFromList } = this.props;
        const watchlistId = result.get('watchlistId');
        const instrumentId = result.get('isin') || result.get('dgsCode');
        const miccode = result.get('market');
        const productCategory = result.get('productCategory');
        const productKey = result.get('productKey');
        const productName = '';

        if (!!watchlistId) {
            deleteProductFromList(watchlistId, instrumentId, miccode, productName, watchlistId, false, productCategory, productKey);
        } else {
            addProductToList(instrumentId, miccode, productCategory, productKey);
        }
    }

    buildWatchlistButton() {
        const { result, watchlistEnabled, rowIndex, immBrokerWatchlist, watchlistTutorialHasBeenShown } = this.props;
        const watchlistId = result.get('watchlistId');
        const starIconClasses = classNames('broker-search-results__star', {
            'broker-search-results__star--disabled': !watchlistId
        });
        const watchlistButton = (
            <span className="broker-advanced-search-result__watchlist-button">
                <OKButton
                    modifier="link-ghost"
                    size="small"
                    autoHeight={true}
                    onClick={this.handleStarClicked}
                >
                    <i className={starIconClasses}></i>
                </OKButton>
            </span>
        );

        const listSelectedIdForParam = immBrokerWatchlist.get('listSelectedIdForParam');
        const watchlistBtnTooltip = rowIndex === 0 && !isNaN(parseInt(listSelectedIdForParam)) && watchlistTutorialHasBeenShown ? (
            <OKTooltip
                target={watchlistButton}
                content="brokerWatchList-brokerWatchList_tooltip"
                defaultVisible={true}
            />
        ) : watchlistButton;

        return watchlistEnabled && (
            <React.Fragment>
                <FormattedText
                    className="broker-advanced-search-result__watchlist-icon-label"
                    value="brokerWatchList-brokerWatchList_addToWatchlist"
                />
                {watchlistBtnTooltip}
            </React.Fragment>
        );
    }

    buildSelectButton() {
        const { handleClickSelectButton, result } = this.props;
        return (
            <div className="col-md-2">
                <OKButton
                    modifier="secondary"
                    size="small"
                    onClick={() => {
                        handleClickSelectButton(result);
                    }}
                >
                    <FormattedText value="broker-broker_selectButtonText" />
                </OKButton>
            </div>
        );
    }

    validateDigit(number) {
        if(parseFloat(number) === 0) {
            return 'info-text-value'
        } else if(parseFloat(number) > 0) {
            return 'positive-rentability'
        } else if(parseFloat(number) < 0) {
            return 'negative-rentability'
        }
    }

    buildFirstCard() {
        const { result, type } = this.props
        let title, content, bottomText, cssClass = 'info-text-value';
        switch (type) {
            case TYPE_ETFS:
            case TYPE_WARRANTS:
            case TYPE_STOCKS:
            case TYPE_CRYPTO:
                title = (
                    <div className="broker-advanced-search-result__info-text-title">
                        <FormattedText value="broker-rightsQuotation" />
                    </div>
                );
                content = !!result.get('quotation')
                    ? `${result.get('quotation')} ${result.get('currency')}`
                    : '-';
                bottomText = result.get('quotationDate') !== null
                    && result.get('quotationDate') !== '-'
                    ? `${result.get('quotationDate')} | ${result.get('quotationTime')}`
                    : null;
                break;
            case ALTERNATIVE_FUNDS:
                title = (
                    <div className="broker-advanced-search-result__info-text-title">
                       <FormattedText value="brokerWealth-minimumInvestment" />
                    </div>
                );
                cssClass = result.get('minInvestment') !== null ? this.validateDigit(result.get('minInvestment').replace(',', '.')) : 'info-text-value';
                content = result.get('minInvestment')
                    ? `${formatAmount(result.get('minInvestment'))} ${result.get('currency')}`
                    : '-';
                break;
            case TYPE_FUNDS:
            case TYPE_PLANS:
                const rentabilityTooltipContent = this.getYtdTooltipContent();
                title = (
                    <div className="broker-advanced-search-result__info-text-title-rentability">
                        <FormattedText value={"brokerAdvancedSearch-brokerAdvancedSearch_rentability"} />
                        <div
                            onMouseEnter={() => { taggingEventHandled(`broker/${this.props.type}`, 'rentabilityTooltip', result.get('shortName')) }}>
                            <OKTooltip
                                content={rentabilityTooltipContent}
                                offset={[1, -10]}
                            />
                        </div>
                    </div>
                );
                cssClass = result.get('minInvestment') !== null ? this.validateDigit(result.get('rentabilityPercentage').replace(',', '.')) : 'info-text-value';
                content = `${result.get('rentabilityPercentage')} ${PERCENTAGE_SYMBOL} `;
                break;
        }
        return (
            <div className="col-sm-4 broker-advanced-search-result__right-info__box">
                {title}
                <div className="broker-advanced-search-result__info-text-value">
                    {content}
                </div>
                <div className="broker-advanced-search-result__info-text-date">
                    {bottomText}
                </div>
            </div>
        );
    }

    buildSecondCard() {
        const { result, type } = this.props
        let title, content, bottomText, cssClass = 'info-text-value';
        switch (type) {
            case TYPE_WARRANTS:
                title = formatText('brokerAdvancedSearch-brokerAdvancedSearch_dailyVariationPercentage');
                cssClass = result.get('dayChangePercentage') !== null ? this.validateDigit(result.get('dayChangePercentage')) : 'info-text-value';
                content = result.get('dayChangePercentage') !== null
                    ? `${formatWithoutRound(result.get('dayChangePercentage'))} ${PERCENTAGE_SYMBOL}`
                    : '-'
                bottomText = result.get('dayChangeDate')
                    ? `${result.get('dayChangeDate')}`
                    : '-';
                break;
            case TYPE_ETFS:
            case TYPE_STOCKS:
            case TYPE_CRYPTO:
                title = formatText('brokerAdvancedSearch-brokerAdvancedSearch_dailyVariationAmount');
                cssClass = result.get('dayChangePrice') !== null ? this.validateDigit(result.get('dayChangePrice')) : 'info-text-value';
                content = result.get('dayChangePrice') !== null
                    ? `${formatWithoutRound(result.get('dayChangePrice'))} ${result.get('currency')}`
                    : '-'
                bottomText = result.get('quotationDate') !== null
                    && result.get('quotationDate') !== '-'
                    ? `${result.get('quotationDate')} | ${result.get('quotationTime')}`
                    : null;
                break;
            case ALTERNATIVE_FUNDS:
                const units = this.getUnits(result.get('mgmtFeeExAnte'));
                const maxDecimals = units <= 1 ? 2 : units >= 4 ? 3 : units;
                title = (
                    <div className="broker-advanced-search-result__info-text-title-rentability-alternative-funds">
                        <FormattedText value="brokerWealth-expectedProfitability" />
                        <div
                            onMouseEnter={() => { taggingEventHandled(`broker/${this.props.type}`, 'rentabilityTooltip', result.get('shortName')) }}>
                            <OKTooltip
                                content={<FormattedText value="brokerAdvancedSearch-brokerAdvancedSearch_rentabilityAlternativeFundsTooltipTitle" />}
                                offset={[1, -10]}
                            />
                        </div>
                    </div>
                )
                const irr = result.get('irr') && formatWithoutRound(result.get('irr'), maxDecimals);
                cssClass = result.get('irr') !== null ? this.validateDigit(result.get('irr')) : 'info-text-value';
                content = irr
                ? `${irr} ${PERCENTAGE_SYMBOL}`
                : '-';
                break;
            case TYPE_FUNDS:
            case TYPE_PLANS:
                title = formatText('brokerAdvancedSearch-brokerAdvancedSearch_lastYearRentability');
                cssClass = result.get('lastYearReturnValue') !== null ? this.validateDigit(result.get('lastYearReturnValue')) : 'info-text-value';
                content = result.get('lastYearReturnValue')
                    ? `${formatWithoutRound(result.get('lastYearReturnValue'), 2)} ${PERCENTAGE_SYMBOL}`
                    : '-';
                break;
        }
        return (
            <div className="col-sm-4 broker-advanced-search-result__right-info__box">
                <div className="broker-advanced-search-result__info-text-title">
                    {title}
                </div>
                <div className={`broker-advanced-search-result__${cssClass}`}>
                    {content}
                </div>
                <div className="broker-advanced-search-result__info-text-date">
                    {bottomText}
                </div>
            </div>
        );
    }

    buildThirtCard() {
        const { result, type } = this.props
        let title, content, bottomText, cssClass = 'info-text-value';;
        switch (type) {
            case TYPE_ETFS:
            case TYPE_STOCKS:
            case TYPE_CRYPTO:
                title = formatText('brokerAdvancedSearch-brokerAdvancedSearch_dailyVariationPercentage');
                cssClass = result.get('dayChangePercentage')
                    ? this.validateDigit(result.get('dayChangePercentage').replace(',', '.'))
                    : 'info-text-value';
                content = result.get('dayChangePercentage')
                    ? `${formatWithoutRound(result.get('dayChangePercentage'), 2)} ${PERCENTAGE_SYMBOL}`
                    : '-';
                bottomText = result.get('quotationDate') !== null
                    && result.get('quotationDate') !== '-'
                    ? `${result.get('quotationDate')} | ${result.get('quotationTime')}`
                    : null;
                break;
            case TYPE_WARRANTS:
                title = formatText('brokerAdvancedSearch-brokerAdvancedSearch_maturity');
                content = result.get('maturity')
                    ? `${formatDate(result.get('maturity'), DATE_FORMAT)}`
                    : '-';
                break;
            case TYPE_FUNDS:
            case TYPE_PLANS:
                title = (
                    <FormattedText
                        value="brokerAdvancedSearch-brokerAdvancedSearch_commissionCostText"
                        className="broker-advanced-search-result__info-text-long-title"
                    />
                );
                const units = this.getUnits(result.get('mgmtFeeExAnte'));
                const maxDecimals = units <= 1 ? 2 : units >= 4 ? 3 : units;
                const commissionCostValue = result.get('mgmtFeeExAnte') && formatWithoutRound(result.get('mgmtFeeExAnte'), maxDecimals);
                content = commissionCostValue
                    ? `${commissionCostValue} ${PERCENTAGE_SYMBOL}`
                    : '-';
                break;
            case ALTERNATIVE_FUNDS:
                title = (
                    <div className="broker-advanced-search-result__info-text-title-rentability-alternative-funds">
                        <FormattedText value="brokerWealth-liquidity" />
                        <div
                            onMouseEnter={() => { taggingEventHandled(`broker/${this.props.type}`, 'frequencyTooltip', result.get('shortName')) }}>
                            <OKTooltip
                                content={<FormattedText value="brokerAdvancedSearch-brokerAdvancedSearch_frequencyAlternativeFundsTooltipTitle" />}
                                offset={[1, -10]}
                            />
                        </div>
                    </div>
                )
                content = result.get('navFrequency')
                ? `${result.get('navFrequency')}`
                : '-';
        }
        return (
            <div className="col-sm-4 broker-advanced-search-result__right-info__box">
                <div className="broker-advanced-search-result__info-text-title">
                    {title}
                </div>
                <div className={`broker-advanced-search-result__${cssClass}`}>
                    {content}
                </div>
                <div className="broker-advanced-search-result__info-text-date">
                    {bottomText}
                </div>
            </div>
        );
    }

    buildSearchResultRightInfo() {
        const { showSelectButton } = this.props;

        const buyButton = !showSelectButton && this.buildBuyButton();
        const watchlistButton = this.buildWatchlistButton();
        const selectButton = showSelectButton && this.buildSelectButton();
        const rightInfoContainerClasses = classNames('row broker-advanced-search-result__info', {
            'broker-advanced-search-result__info--with-select': showSelectButton,
        });
        const rightInfoClass = classNames('broker-advanced-search-result__info', {
            'col-md-10': showSelectButton
        });
        const firstCard = this.buildFirstCard();
        const secondCard = this.buildSecondCard();
        const thirtCard = this.buildThirtCard();
        return (
            <div className="col-sm-8 broker-advanced-search-result__right-info">
                <div className={rightInfoContainerClasses}>
                    <div className={rightInfoClass}>
                        {firstCard}
                        {secondCard}
                        {thirtCard}
                    </div>
                    {selectButton}
                </div>
                <div className="row broker-advanced-search-result__button-container">
                    <span className="broker-advanced-search-result__button">
                        {buyButton}
                    </span>
                    <span className="broker-advanced-search-result__watchlist-actions">
                        {watchlistButton}
                    </span>
                </div>
            </div>
        );
    }

    render() {
        const searchResultLeftInfo = this.buildSearchResultLeftInfo();
        const searchResultRightInfo = this.buildSearchResultRightInfo();

        return (
            <React.Fragment>
                <Prompt message={() => false} when={this.state.isBlockingRouteChange} />
                <div className="row broker-advanced-search-result">
                    <OKModal
                        description={"us_person_popup-pension_plans_hire_block_message"}
                        descriptionAlignment="center"
                        footerType="action"
                        isOpen={this.state.openModalUsPerson}
                        onCloseCallback={() => this.setState({ openModalUsPerson: false })}
                        onPrimaryButtonClick={() => this.setState({ openModalUsPerson: false })}
                        primaryButtonText={"us_person_popup-confirm_button_title"}
                        title={"us_person_popup-pension_plans_hire_block_title"}
                        titleAlignment="center"
                    />
                    {searchResultLeftInfo}
                    {searchResultRightInfo}
                </div>
            </React.Fragment>
        );
    }
}

BrokerAdvancedSearchResult.propTypes = {
    addProductToList: PropTypes.func.isRequired,
    deleteProductFromList: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object,
    result: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
    immbrokerClientWarningModal: PropTypes.object,
    immBrokerWatchlist: PropTypes.object,
    immTutorial: PropTypes.object,
    showClientWarningModal: PropTypes.func,
    getDgsCodeToSecIDURL: PropTypes.func,
    buyButtonClick: PropTypes.func,
    productLinkNameTagging: PropTypes.func,
    checkPersonalInformationData: PropTypes.func,
    hasNoStockContracts: PropTypes.bool,
    showModal: PropTypes.func.isRequired,
    showSelectButton: PropTypes.bool,
    handleClickSelectButton: PropTypes.func,
    watchlistEnabled: PropTypes.bool,
    watchlistTutorialHasBeenShown: PropTypes.bool,
    rowIndex: PropTypes.number,
    pageName: PropTypes.string,
    immBrokerUsPersonBlock: PropTypes.object,
    history: PropTypes.object.isRequired,
};

BrokerAdvancedSearchResult.defaultProps = {
    showSelectButton: false,
    handleClickSelectButton: () => { },
    pageName: ''
}

module.exports = BrokerAdvancedSearchResult;
module.exports.BrokerAdvancedSearchResult = connect(
    state => ({
        flagBasedFeatures: state.flagBasedFeatures,
        immbrokerClientWarningModal: state.brokerClientWarningModal,
        immBrokerWatchlist: state.brokerWatchlist,
        immTutorial: state.tutorial,
        immBrokerUsPersonBlock: state.brokerIsUsPerson
    }),
    {
        showClientWarningModal: BrokerClientWarningModalAction.showClientWarningModal,
        getDgsCodeToSecIDURL: morningstarPlansDgsCodeToSecIDActions.getDgsCodeToSecIDURL,
        buyButtonClick: BrokerProductAdvancedSearchActions.buyButtonClick,
        productLinkNameTagging: BrokerAdvancedSearchTaggingActions.productLinkNameTagging,
        showModal: brokerNoStockAccountModalActions.showModal,
        checkPersonalInformationData: BrokerClientWarningModalAction.checkPersonalInformationData,
    }
)(withRouter(BrokerAdvancedSearchResult));
